import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["countdown", "ring"]
  static values = {
    startedAt: String,
    targetMinutes: Number,
    timerMode: String
  }

  connect() {
    this.update()
    this.timer = setInterval(() => this.update(), 1000)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  update() {
    if (!this.hasCountdownTarget) return
    if (!this.startedAtValue) {
      this.countdownTarget.textContent = "00:00:00"
      if (this.hasRingTarget) {
        this.ringTarget.style.setProperty("--fasting-progress", "0%")
      }
      return
    }
    const startedAt = new Date(this.startedAtValue)
    if (Number.isNaN(startedAt.getTime())) {
      this.countdownTarget.textContent = "00:00:00"
      if (this.hasRingTarget) {
        this.ringTarget.style.setProperty("--fasting-progress", "0%")
      }
      return
    }
    const targetMinutes = Number(this.targetMinutesValue || 0)
    const elapsedMs = Date.now() - startedAt.getTime()
    const totalSeconds = Math.max(0, Math.floor(elapsedMs / 1000))
    const mode = this.timerModeValue || "count_up"

    if (mode === "count_down" && targetMinutes > 0) {
      const remainingSeconds = Math.floor(targetMinutes * 60) - totalSeconds
      if (remainingSeconds >= 0) {
        this.countdownTarget.textContent = this.formatDuration(remainingSeconds)
      } else {
        this.countdownTarget.textContent = `+${this.formatDuration(Math.abs(remainingSeconds))}`
      }
    } else {
      this.countdownTarget.textContent = this.formatDuration(totalSeconds)
    }

    if (this.hasRingTarget && targetMinutes > 0) {
      const elapsedMinutes = Math.max(0, Math.round(elapsedMs / 60000))
      const progress = Math.min(1, elapsedMinutes / targetMinutes)
      this.ringTarget.style.setProperty("--fasting-progress", `${Math.round(progress * 100)}%`)
    }
  }

  formatDuration(totalSeconds) {
    const safeSeconds = Math.max(0, Math.floor(totalSeconds))
    const hours = Math.floor(safeSeconds / 3600)
    const minutes = Math.floor((safeSeconds % 3600) / 60)
    const seconds = safeSeconds % 60
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`
  }
}
